import type { SxProps, Theme } from '@mui/material/styles';
import { navigationTokens } from '@peritasai/ui-shared';
import { DRAWER_WIDTH, DRAWER_WIDTH_COLLAPSED, SIDEBAR_BG_COLOR } from './constants';

export const drawerContentSx = (isCollapsed: boolean): SxProps<Theme> => ({
  width: isCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  overflowX: 'hidden!important',
  alignItems: 'stretch',
  padding: '24px 12px 0px',
  backgroundColor: SIDEBAR_BG_COLOR,
  transition: 'width 0.3s ease-in-out',
});

export const headerContainerSx: SxProps<Theme> = {
  width: '100%',
  alignItems: 'center',
  padding: '0.7rem 0rem 1rem 0rem',
};

export const headerRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
};

export const collapsedLogoSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
};

export const collapseToggleSx: SxProps<Theme> = {
  cursor: 'pointer',
  padding: '4px',
  borderRadius: '4px',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
};

export const navSectionSx: SxProps<Theme> = {
  flex: 0,
  width: 'calc(100% + 18px)',
  marginTop: 0,
  ml: '-6px',
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarGutter: 'stable',
  minHeight:'calc(100vh - 240px)',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '8px',
    backgroundColor: navigationTokens.scrollbarThumb,
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
};

export const bottomSectionSx = (isCollapsed: boolean): SxProps<Theme> => ({
  width: '100%',
  marginTop: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: isCollapsed ? 'center' : 'flex-start',
  paddingBottom: '24px',
  paddingTop: '12px',
  gap: '8px',
  flexShrink: 0,
  minHeight: '120px',
  position: 'sticky',
  bottom: 0,
  backgroundColor: SIDEBAR_BG_COLOR,
});

export const bottomDividerSx: SxProps<Theme> = {
  width: '100%',
  height: '1px',
  backgroundColor: navigationTokens.divider,
  marginTop: '8px',
  marginBottom: '12px',
};

export const bottomBrandSx: SxProps<Theme> = {
  fontSize: '8px',
  letterSpacing: '0.4px',
  color: navigationTokens.brandText,
  textAlign: 'center',
  width: '100%',
};

export const drawerPaperSx = (isCollapsed: boolean) =>
  ({
    width: isCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH,
    transition: 'width 0.3s ease-in-out',
    border: 'none',
    boxSizing: 'border-box',
    top: 0,
    height: '100vh',
    backgroundColor: SIDEBAR_BG_COLOR,
  } satisfies SxProps<Theme>);
